import { useEffect, useState } from 'react';
import { useAppUserStore } from '@data/storage';

export const useHydration = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const unsubFinishHydration = useAppUserStore.persist.onFinishHydration(() => setHydrated(true));

    setHydrated(useAppUserStore.persist.hasHydrated());

    return () => {
      unsubFinishHydration();
    };
  }, []);

  return hydrated;
};
